import { SimplePlaceholder } from "@components"
import { XCircleIcon } from '@heroicons/react/24/outline'

const ErrorLoadingPlaceholder = () => (
  <SimplePlaceholder 
    title="Error Loading Delivery Stats" 
    icon={XCircleIcon}
    isFullHeight={false}
  >
    <p className='mb-4'>There was an error loading the delivery stats for this notification.</p>
    <p className='mb-4'>Please try again later or contact support if the issue persists.</p>
  </SimplePlaceholder>
)

export default ErrorLoadingPlaceholder